import ReceiptPaymentModeSummary from "@/components/receipt-payment-summary/ReceiptPaymentModeSummary";
import type { PaymentSummaryResponse } from "@/components/receipt-payment-summary/types";
import {
  buildFmbSummaryQuery,
  FMB_PAYMENT_SUMMARY_PATH,
  FMB_SUMMARY_QUERY_KEYS,
  fmbPaymentSummaryCardsFromResponse,
  shouldFetchFmbPaymentSummary,
} from "./fmb-receipt-payment-summary";

const parseFmbPaymentSummaryResponse = (json: unknown): PaymentSummaryResponse | null =>
  json && typeof json === "object" ? (json as PaymentSummaryResponse) : null;

export default function FmbReceiptPaymentSummary() {
  return (
    <ReceiptPaymentModeSummary
      apiResource="fmbReceipt"
      summaryPath={FMB_PAYMENT_SUMMARY_PATH}
      queryKeys={FMB_SUMMARY_QUERY_KEYS}
      shouldFetch={shouldFetchFmbPaymentSummary}
      buildQuery={buildFmbSummaryQuery}
      parseResponse={parseFmbPaymentSummaryResponse}
      cardsFromResponse={fmbPaymentSummaryCardsFromResponse}
    />
  );
}
